import styled from 'styled-components';
import { FolderClosed } from 'ui/icons/action/FolderClosed';
import { body2, colors, spacing } from 'ui/theme';
import { DeletableItem } from '../../types';

type BulkDeletionDetailsProps = {
  content: DeletableItem[];
  folders: DeletableItem[];
};

export const BulkDeletionDetailsList = styled.ul`
  ${body2}
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
  padding: ${spacing.base};
  border-radius: ${spacing.quarter};
  background: ${colors.backgroundSecondary};
  border: 1px solid ${colors.borderPrimary};
  max-height: ${spacing.x24};
  overflow-y: auto;

  li {
    list-style: none;

    svg {
      vertical-align: bottom;
      margin-right: ${spacing.half};
    }
  }
`;

export const BulkDeletionDetails = ({ content, folders }: BulkDeletionDetailsProps) => (
  <BulkDeletionDetailsList>
    {folders.map(({ id, name }) => (
      <li key={`folder-${id}`}>
        <FolderClosed />
        {name}
      </li>
    ))}
    {content.map(({ id, name }) => (
      <li key={`content-${id}-${name}`}>{name}</li>
    ))}
  </BulkDeletionDetailsList>
);
